import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import Sortable from 'sortablejs';
import ApiService from '../../services/apiService';
import NiotaClassicApiService from '../../services/niotaClassicApiService';
import chunk from 'lodash/chunk';
export default {
  name: 'ViewVirtualDevicesViews',
  data: function data() {
    return {
      showCreateDialog: false,
      showDeletePrompt: false,
      editItem: {},
      deleteViewId: null,
      selectedAccountIds: [],
      deviceTypes: [],
      deviceDrivers: [],
      viewList: [],
      currentPageItems: [],
      totalCount: -1,
      accounts: [],
      iteratorPage: 1,
      iteratorPerPage: 12,
      firstFetch: true,
      isFetchingList: true,
      isFetchingExecute: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled', 'language', 'permissions'])), mapGetters({
    tenantId: 'authentication/tenantId',
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    canWriteViews: function canWriteViews() {
      return this.permissions['VirtualDevice.write'] || this.permissions['VirtualDevice.manage'];
    },
    canManageViews: function canManageViews() {
      return this.permissions['VirtualDevice.manage'];
    },
    cardActions: function cardActions() {
      return [].concat(_toConsumableArray(this.canWriteViews ? ['edit'] : []), _toConsumableArray(this.canManageViews ? ['delete'] : []));
    },
    hasNoMonitoringViews: function hasNoMonitoringViews() {
      return this.viewList.length === 0;
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems: function operationalStatusItems() {
      var _this = this;

      return Object.keys(this.operationalStatus).map(function (status) {
        return {
          text: _this.operationalStatus[status],
          value: status
        };
      });
    }
  }),
  watch: {
    language: function language() {
      var _this2 = this;

      this.viewList.map(function (view) {
        if (view.viewConfig && view.viewConfig.searchItems) {
          view.tags = view.viewConfig.searchItems.map(function (item) {
            return _this2.createTag(item.variable, item.search);
          });
        }
      });
    },
    selectedAccountIds: function selectedAccountIds() {
      this.loadViews();
    }
  },
  created: function created() {
    var _this3 = this;

    NiotaClassicApiService.deviceTypesGetPlain().then(function (response) {
      _this3.deviceTypes = response.data.devicetypes;
    }).catch(function (error) {
      console.error(error);
    });
    ApiService.virtualDeviceDrivers.fetch({
      fields: ['id', 'title']
    }).then(function (res) {
      _this3.deviceDrivers = res.deviceDrivers;
    }).catch(function (error) {
      console.error(error);
    });
  },
  mounted: function mounted() {// this.initDraggable(); // disabled as API does not support reordering
  },
  methods: {
    handleItemsPerPageChange: function handleItemsPerPageChange(itemsPerPage) {
      this.iteratorPerPage = itemsPerPage;
      this.fetchCardDataForPage();
    },
    handlePageChange: function handlePageChange(page) {
      this.iteratorPage = page;
      this.fetchCardDataForPage();
    },
    fetchCardDataForPage: function () {
      var _fetchCardDataForPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var start, end, executePromises, chunkLength, chunkedPromises, _loop, i;

        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isFetchingExecute = true;
                start = (this.iteratorPage - 1) * this.iteratorPerPage;
                end = start + this.iteratorPerPage;
                this.currentPageItems = this.viewList.slice(start, end);
                executePromises = this.currentPageItems.map(function (view) {
                  return _this4.fetchViewExecute(view.id);
                });

                if (!(this.viewList.length === 0)) {
                  _context2.next = 9;
                  break;
                }

                // in case there is nothing to fetch, set flags right here,
                // rather than waiting for the `finally`-block of the promises,
                // for an empty-list the for-loop underneath will never be executed
                this.firstFetch = false;
                this.isFetchingExecute = false;
                return _context2.abrupt("return");

              case 9:
                // only load data for 4 views at a time
                chunkLength = 4;
                chunkedPromises = chunk(executePromises, chunkLength);
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                  return regeneratorRuntime.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return Promise.allSettled(chunkedPromises[i]).then(function (results) {
                            var pageResult = _this4.currentPageItems.map(function (view, index) {
                              // only handle the results for which the chunked-promises fetched right now
                              if (index < chunkLength * i || index >= chunkLength * i + chunkLength) {
                                return view;
                              }

                              var result = results[index - chunkLength * i];

                              if (result.status === 'fulfilled' && result.value !== undefined) {
                                var data = result.value;
                                return _objectSpread(_objectSpread({}, view), {}, {
                                  isFetchingExecute: false,
                                  // flag for the skeleton-loaders
                                  account: (_this4.findAccountById(view.tenantId) || {}).name || '--',
                                  accountId: view.tenantId,
                                  devices: data.total,
                                  errors: data.alert,
                                  warnings: data.warn,
                                  tags: view.viewConfig.searchItems.map(function (item) {
                                    return _this4.createTag(item.variable, item.search);
                                  })
                                });
                              } else {
                                return {
                                  id: view.id,
                                  isFetchingExecute: false,
                                  // flag for the skeleton-loaders
                                  account: (_this4.findAccountById(view.tenantId) || {}).name || '--',
                                  accountId: view.tenantId,
                                  title: view.title,
                                  devices: '-',
                                  errors: '-',
                                  warnings: '-',
                                  tags: []
                                };
                              }
                            });

                            _this4.currentPageItems = pageResult;
                          }).catch(function (error) {
                            // Promise.allSettled(executePromises) failed
                            console.error(error);
                          }).finally(function () {
                            // set flags as soon as first chunk is finished.
                            // unfinished chunks will still have the `isFetchingExecute != false` set inside the model
                            _this4.firstFetch = false;
                            _this4.isFetchingExecute = false;
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 13:
                if (!(i < chunkedPromises.length)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.delegateYield(_loop(i), "t0", 15);

              case 15:
                i++;
                _context2.next = 13;
                break;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCardDataForPage() {
        return _fetchCardDataForPage.apply(this, arguments);
      }

      return fetchCardDataForPage;
    }(),
    accountSelectionChanged: function accountSelectionChanged(accounts) {
      this.selectedAccountIds = accounts.map(function (account) {
        return account.id;
      });
    },
    accountsLoaded: function accountsLoaded() {
      this.accounts = this.$store.state.app.n2Accounts.accounts;
    },
    findAccountById: function findAccountById(id) {
      return this.accounts.find(function (account) {
        return account.id === id;
      });
    },
    fetchAccounts: function fetchAccounts() {
      var _this5 = this;

      return this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        return _this5.accounts = accounts;
      });
    },
    fetchViewExecute: function fetchViewExecute(viewId) {
      return ApiService.virtualDeviceViewsExecute(this, viewId).then(function (response) {
        return response;
      }).catch(function (error) {
        console.error(error);
      });
    },
    createTag: function createTag(variable, text) {
      if (variable === 'operationalStatus') {
        text = this.operationalStatus[text] || text;
      }

      if (['deviceType', 'deviceDriver'].includes(variable)) {
        var dataArray = this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback') ? this.deviceTypes : this.deviceDrivers;
        var matchedData = dataArray.find(function (type) {
          return type.id === parseInt(text, 10);
        });

        if (matchedData) {
          text = matchedData.title;
        }
      }

      return {
        type: variable,
        text: text
      };
    },
    loadViews: function loadViews() {
      var _this6 = this;

      this.firstFetch = true;
      this.isFetchingList = true;
      ApiService.virtualDeviceViewsFetch(this, {
        tenantIds: this.selectedAccountIds
      }).then(function (response) {
        _this6.viewList = response;
        _this6.totalCount = _this6.viewList.length;

        _this6.fetchCardDataForPage();
      }).catch(function (error) {
        // Promise.allSettled(executePromises) failed
        console.error(error);

        _this6.$snack(_this6.$i18n_t('DigitalTwin.VirtualDevice.snacks.loadMonitoringViewFailed'), 'error');
      }).finally(function () {
        _this6.isFetchingList = false;
      });
    },
    initDraggable: function initDraggable() {
      var grid = document.querySelector('.view-card-grid');
      Sortable.create(grid, {
        handle: '.view-card-drag-handle',
        ghostClass: 'view-card-drag-placeholder',
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;
          console.info('move card from', oldIndex, 'to', newIndex);
        }
      });
    },
    handleDelete: function handleDelete(id) {
      this.deleteViewId = id;
      this.showDeletePrompt = true;
    },
    handleEdit: function handleEdit(id) {
      this.editItem = this.viewList.find(function (view) {
        return view.id === id;
      });
      this.showCreateDialog = true;
    },
    handleConfirmedDelete: function handleConfirmedDelete() {
      var _this7 = this;

      ApiService.virtualDeviceViewDelete(this, this.deleteViewId).then(function () {
        _this7.loadViews();
      }).catch(function (error) {
        // ApiService.virtualDeviceViewDelete failed
        console.error(error);
      }).finally(function () {
        _this7.showDeletePrompt = false;
      });
    },
    handleCreate: function handleCreate(options) {
      var _this8 = this;

      ApiService.virtualDeviceViewCreate(this, options).then(function () {
        _this8.loadViews();
      }).catch(function (error) {
        // ApiService.virtualDeviceViewCreate failed
        console.error(error);
      });
    },
    // if feature-flag `rd-6855` is disabled, there still is an EDIT view, rather than just create
    handleUpdate: function handleUpdate(options) {
      var _this9 = this;

      ApiService.virtualDeviceViewUpdate(this, options).then(function () {
        _this9.loadViews();
      }).catch(function (error) {
        // ApiService.virtualDeviceViewUpdate failed
        console.error(error);
      });
    }
  }
};